<template>
  <div
    :class="[' flex-col items-center justify-start logo_wrapper', $attrs.size === 'sm' ? 'sm' : '']"
  >
    <svg
      v-bind="$attrs"
      v-on="$listeners"
      :class="['logo', $attrs.inverted ? 'white' : '']"
      viewBox="0 0 441.000000 298.000000"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="xMidYMid meet"
    >
      <g transform="translate(0.000000,298.000000) scale(0.100000,-0.100000)" stroke="none">
        <path
          d="M310 2130 c-47 -11 -87 -58 -95 -112 -3 -24 -5 -282 -3 -573 3 -584
1 -560 65 -602 25 -17 67 -18 553 -18 483 0 528 1 557 18 61 33 63 43 63 383
l0 306 -39 39 -39 39 -321 0 -321 0 0 -130 0 -130 225 0 225 0 0 -130 0 -130
-350 0 -350 0 0 390 0 390 420 0 420 0 0 135 0 135 -487 -1 c-269 -1 -504 -5
-523 -9z"
        />
        <path
          d="M1650 1520 l0 -620 28 -30 c38 -43 77 -50 297 -50 219 0 259 7 297
49 l27 30 33 -33 c29 -29 43 -35 100 -41 37 -4 149 -5 250 -3 158 3 187 6 211
22 59 39 57 20 57 686 l0 610 -135 0 -135 0 0 -525 0 -525 -125 0 -125 0 0
395 0 395 -135 0 -135 0 0 -395 0 -395 -120 0 -120 0 0 525 0 525 -135 0 -135
0 0 -620z"
        />
        <path
          d="M3268 2131 c-20 -4 -44 -14 -53 -21 -45 -37 -45 -35 -45 -680 l0
-610 135 0 135 0 0 260 0 260 325 0 325 0 0 135 0 135 -325 0 -325 0 0 130 0
130 390 0 390 0 0 135 0 135 -457 -1 c-252 -1 -475 -5 -495 -8z"
        />
      </g>
    </svg>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.logo {
  fill: theme('colors.primary.DEFAULT');
}
.logo.white {
  fill: #ffffff;
}
</style>
